export enum Modals {
  BRAND = "BRAND",
  LINK = "LINK",
  ONBOARDING = "ONBOARDING",
  OPTIN = "OPTIN",
  SEARCH = "SEARCH",
}
